<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->
<template>
  <div id="map" style="width:75rem;height:30rem;position:relative">
    <a-input style="z-index:999" ref="tagInput" type="text" size="small"
      :style="{ width: '78px', position: 'absolute', left: '10rem', top: '1rem' }" :value="tagInputValue"
      @change="handleInputChange" @keyup.enter="searchPoint" />
    <a-button @click="getGeomeryData" style="position:absolute;right:22rem;z-index:5;top:1rem">获取数据</a-button>
    <a-button @click="deleteOne" style="position:absolute;right:18rem;z-index:5;top:1rem">撤销</a-button>
    <a-button @click="removeAllDraw" style="position:absolute;right:14rem;z-index:5;top:1rem">清除</a-button>
    <a-button @click="addInteraction('Point')" style="position:absolute;right:10rem;z-index:5;top:1rem">点</a-button>
    <a-button @click="addInteraction('LineString')" style="position:absolute;right:6rem;z-index:5;top:1rem">线</a-button>
    <a-button @click="addInteraction('Polygon')" style="position:absolute;right:2rem;z-index:5;top:1rem">面</a-button>
  </div>
</template>

<script>

import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
// import { get as getProjection } from 'ol/proj'
import Draw from 'ol/interaction/Draw'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
import Circle from 'ol/style/Circle'
import { searchPlace } from '@/api/manage'
import * as olProj from 'ol/proj'
import streetData from './test.json'
import GeoJSON from 'ol/format/GeoJSON'

export default {
  name: 'MyMap',
  data () {
    return {
      map: null,
      tagInputValue: ''
    }
  },
  mounted () {
    this.initMap()
    this.addGeojson(streetData)
  },
  methods: {
    // 添加geojson
    addGeojson (geojsonObject) {
      var vectorSource = new VectorSource({
        features: (new GeoJSON()).readFeatures(geojsonObject)
      })
      var vectorLayer = new VectorLayer({
        source: vectorSource
      })
      this.map.addLayer(vectorLayer)
    },
    // 输入改变
    handleInputChange (e) {
      // debugger
      // console.log(window.origin)
      this.tagInputValue = e.target.value
    },
    // 初始化地图
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      // var projection = getProjection('EPSG:4326')
      this.map = new Map({
        view: new View({
          center: [106.456878, 29.541145], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 7, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        target: 'map' // 地图容器id
      })
      var roadLayer = new TileLayer({
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      this.map.addLayer(roadLayer)
    },
    // 开启、关闭交互
    addInteraction (type) {
      if (this.draw) {
        this.map.removeInteraction(this.draw)
      }
      var source = new VectorSource()
      var vectorLayer = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({ // 填充样式
            color: 'rgba(255, 255, 255, 0.2'
          }),
          stroke: new Stroke({ // 线样式
            color: '#00c033',
            width: 2
          }),
          image: new Circle({ // 点样式
            radius: 7,
            fill: new Fill({ color: '#00c033' })
          })
        })
      })
      this.map.addLayer(vectorLayer)
      this.draw = new Draw({
        source: source,
        type: type // 几何图形类型
        // geometryFunction: geometryFunction             //几何信息变更时的回调函数
      })
      this.map.addInteraction(this.draw)
    },
    // 清除全部
    removeAllDraw () {
      this.map.getLayers().array_.forEach(item => {
        item.getSource().clear()
      })
    },
    deleteOne () {
      var length = this.map.getLayers().array_.length
      var allFeatures = this.map.getLayers().array_[length - 1].getSource().getFeatures()
      var featureLength = allFeatures.length
      if (featureLength === 0) {
        this.map.removeInteraction(this.draw)
        this.map.removeLayer(this.map.getLayers().array_[length - 1])
        length = this.map.getLayers().array_.length
        allFeatures = this.map.getLayers().array_[length - 1].getSource().getFeatures()
        featureLength = allFeatures.length
      }
      var newFeature = allFeatures[featureLength - 1]
      this.map.getLayers().array_[length - 1].getSource().removeFeature(newFeature)
    },
    // 地图打点
    addSimplePoint (x, y) {
      var point = new Point([x, y])
      var feature = new Feature(point)
      var vectorSource = new VectorSource()
      vectorSource.addFeature(feature)
      var vectorLayer = new VectorLayer({
        source: vectorSource,
        style: new Style({
          fill: new Fill({ // 填充样式
            color: 'rgba(255, 255, 255, 0.2'
          }),
          stroke: new Stroke({ // 线样式
            color: '#00c033',
            width: 2
          }),
          image: new Circle({ // 点样式
            radius: 7,
            fill: new Fill({
              color: '#00c033'
            })
          })
        })
      })

      this.map.addLayer(vectorLayer)
    },
    // 找点位
    searchPoint () {
      searchPlace(this.tagInputValue).then(res => {
        // debugger
        // console.log('workplace -> call getRoleList()', res)
        if (res.pois.length > 0) {
          var findPointXY = res.pois[0].entr_location
          findPointXY = findPointXY.split(',')
          findPointXY[0] = Number(findPointXY[0])
          findPointXY[1] = Number(findPointXY[1])
        }
        this.addSimplePoint(findPointXY[0], findPointXY[1])
        this.map.getView().setCenter(findPointXY)
      })
    },
    getGeomeryData () {
      var allLayer = this.map.getLayers().array_
      allLayer.forEach(item => {
        if (item.values_.title !== '高德地图') {
          var Geom = item.getSource().getFeatures()
          console.log('geom', Geom)
          Geom.forEach(items => {
            // 坐标点
            console.log(items.getGeometry().getCoordinates())
            // 数据类型（点、线、面、多面）
            console.log(items.getGeometry().getType())
          })
        }
      })
    }
  }
}
</script>

<style>
.map {
  width: 100%;
  height: 100%;
}
</style>
